import VCombobox from './VCombobox'

/* istanbul ignore next */
VCombobox.install = function install (Vue) {
  Vue.component(VCombobox.name, VCombobox)
}

export { VCombobox }
export default VCombobox
